import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { Supplier } from "../interfaces/Supplier";
import { camelToSnake } from "../utils/CamelToSnake";

// CREATE new supplier
export const createSupplier = (payload: Supplier) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/suppliers`,camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET all suppliers
export const getSuppliers = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/suppliers`,  { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET single supplier by ID
export const getSupplierById = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/suppliers/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// UPDATE supplier
export const updateSupplier = (id: number | string, payload: Supplier) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/suppliers/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

